/**
 * What a loaded file DECLARED about springs (ADR-038), remembered against the
 * scene the loader returned — a root extension never reaches the scene graph,
 * and the doors that act on a character after the load (the session driver,
 * the viewport) hold only the scene. A side table, not userData: userData is
 * written back out as `extras` by the exporter, and a declaration must leave
 * through the export door's own `springs` option, once.
 *
 * Depends on: kernel (types). Depended on by: load-glb (writes), the app (reads).
 */
import type { Object3D } from 'three';
import type { SpringDeclaration } from '@harryhausen/kernel';

const declared = new WeakMap<Object3D, readonly SpringDeclaration[]>();

export function rememberDeclaredSprings(scene: Object3D, springs: readonly SpringDeclaration[]): void {
  declared.set(scene, springs);
}

/** The springs the file behind `scene` declared; empty when none (or the scene was not loaded from a file). */
export function declaredSprings(scene: Object3D): readonly SpringDeclaration[] {
  return declared.get(scene) ?? [];
}
